import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import Container from "./Container.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";
import Entity from "../datasource/Entity";

class UsersContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("users");
    }

    getHotelsData = async () => {
        const hotelsEntity = new Entity("hotels");
        try {
            const hotels = await hotelsEntity.getAll();
            this.setState((state) => ({ ...state, hotelsData: hotels }));
        } catch {
            alert("Ошибка получения данных отелей!");
        }
    };

    getPlacesSale = async () => {
        const placesSale = new Entity("places_sales");
        try {
            let places_sales = await placesSale?.getAll();
            places_sales = places_sales?.filter((p) => p.active)
            this.setState((state) => ({ ...state, places_sales }));
        } catch(e) {
            console.error(e)
            alert("Ошибка получения точек продаж!");
        }
    };

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        if (this.props.user) {
            const userType = this.props.user.type;

            switch (userType) {
                case "operator":
                    return <Route render={() => <Redirect to="/" replace />} />;
                case "manager":
                    this.getBackLink = () => this.datasource.routes().home;

                    this.toggleItem = (id, status) => {
                        this.setLoading(() =>
                            this.datasource
                                .toggle(id, status)
                                .then(() => {
                                    this.getAllItems({ type: "operators" });
                                })
                                .catch((error) => {
                                    this.handleUpdateError(error.response);
                                }),
                        );
                    };

                    return (
                        <Switch>
                            <Route path={routes.home} exact>
                                <AllItems
                                    title={"Список операторов"}
                                    columns={{
                                        id: "Id",
                                        name: "Логин",
                                        email: "Email",
                                        company: "Организация",
                                        active: "Активен",
                                    }}
                                    params={{ type: "operators" }}
                                    initAction={this.getAllItems}
                                    items={this.state.AllItems}
                                    loading={this.state.loading}
                                    viewAction={this.getViewLink}
                                    toggleAction={this.toggleItem}
                                />
                            </Route>
                            <Route path={routes.view(":id")} exact>
                                <ViewForm
                                    loading={this.state.loading}
                                    title="Просмотр оператора"
                                    fields={fields}
                                    initAction={this.getItem}
                                    item={this.state.currentItem}
                                    getBackLink={this.getBackLink}
                                />
                            </Route>
                        </Switch>
                    );
            }
        }

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title={"Список пользователей"}
                        columns={{
                            id: "Id",
                            name: "Логин",
                            type: "Тип пользователя",
                            active: "Активен",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        getHotelsAction={this.getHotelsData}
                        hotelsData={this.state.hotelsData}
                        fields={fields}
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новый пользователь"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                        getPlacesSale={this.getPlacesSale}
                        placesSale={this.state?.places_sales}
                    />
                </Route>
                <Route path={routes.view(":id")} exact>
                    <ViewForm
                        loading={this.state.loading}
                        title="Просмотр пользователя"
                        fields={fields}
                        initAction={this.getItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        title="Редактирование пользователя"
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        getPlacesSale={this.getPlacesSale}
                        placesSale={this.state?.places_sales}
                    />
                </Route>
            </Switch>
        );
    };
}

export default UsersContainer;
